"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosTransferInvoiceCreateInputSchema = exports.APosTransferInvoiceSchema = exports.APosTransferInvoiceItemSchema = exports.APosTransferInvoiceStatusSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosTransferInvoiceStatusSchema = zod_1.z.enum([
    'draft', 'approved', 'completed', 'cancelled',
]);
exports.APosTransferInvoiceItemSchema = zod_1.z.object({
    lineId: id_schema_1.EntityIdSchema,
    variantId: id_schema_1.EntityIdSchema,
    displayName: zod_1.z.string().min(1),
    sku: zod_1.z.string().optional(),
    quantity: zod_1.z.number().int().positive(),
    transferPrice: zod_1.z.number().nonnegative(),
    lineTotal: zod_1.z.number().nonnegative(),
});
exports.APosTransferInvoiceSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    transferInvoiceId: id_schema_1.EntityIdSchema,
    invoiceNumber: zod_1.z.string().min(1),
    sourceLocationId: id_schema_1.EntityIdSchema,
    destinationLocationId: id_schema_1.EntityIdSchema,
    stockTransferId: id_schema_1.EntityIdSchema.optional(),
    items: zod_1.z.array(exports.APosTransferInvoiceItemSchema).min(1),
    subtotal: zod_1.z.number().nonnegative(),
    grandTotal: zod_1.z.number().nonnegative(),
    status: exports.APosTransferInvoiceStatusSchema.default('draft'),
    approvedBy: id_schema_1.EntityIdSchema.optional(),
    approvedAt: zod_1.z.number().optional(),
    completedAt: zod_1.z.number().optional(),
    notes: zod_1.z.string().max(2000).optional(),
    createdBy: id_schema_1.EntityIdSchema,
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosTransferInvoiceCreateInputSchema = zod_1.z.object({
    sourceLocationId: id_schema_1.EntityIdSchema,
    destinationLocationId: id_schema_1.EntityIdSchema,
    stockTransferId: id_schema_1.EntityIdSchema.optional(),
    items: zod_1.z.array(zod_1.z.object({
        variantId: id_schema_1.EntityIdSchema,
        displayName: zod_1.z.string().min(1),
        sku: zod_1.z.string().optional(),
        quantity: zod_1.z.number().int().positive(),
        transferPrice: zod_1.z.number().nonnegative(),
    })).min(1),
    notes: zod_1.z.string().max(2000).optional(),
});
//# sourceMappingURL=transfer-invoice.schema.js.map